import type { ImageLoadData } from '@/map-phaser-new/interfaces'

export const clubsMapImageLoadData: () => ImageLoadData[] = () => [
  {
    name: 'clubsMap',
    compressed: true,
    data: {
      astc: {
        type: 'KTX',
        textureURL: 'map/compressed/club_map_BG_v2_astc12.ktx',
      },
      etc: {
        type: 'KTX',
        textureURL: 'map/compressed/club_map_BG_v2_etc2rgba.ktx',
      },
      img: {
        textureURL: 'map/club_map_BG_v2.avif',
      },
      place: 'map/club_map_BG_v2.avif',
    },
  },
  {
    name: 'club-overlay',
    compressed: true,
    data: {
      astc: {
        type: 'KTX',
        textureURL: 'map/compressed/overlay_clubs_v2_astc12.ktx',
      },
      etc: {
        type: 'KTX',
        textureURL: 'map/compressed/overlay_clubs_v2_etc2rgba.ktx',
      },
      img: {
        textureURL: 'map/club-overlay_v2.avif?v1',
      },
      place: 'map/club-overlay_v2.avif?v1',
    },
  },
]
